<template>
  <div>
    <div>
      <div v-if="isLoading" class="loader">
        <q-spinner-grid color="black" size="5em" />
        <q-tooltip :offset="[0, 8]">QSpinnerGrid</q-tooltip>
      </div>
      <q-btn style="position:absolute; top:5px; left:5px; z-index: 10000;" icon="museum" flat round dense
        :color="navIconColor" @click="returnToBegin" />
      <div id="mainContainer" class="mainContainer animate__animated animate__zoomIn" v-if="!hasHomeImage">
        <canvas ref="canvasRef"></canvas>
        <ShowRights v-if="exhibitId" :exhibitId="exhibitId" />

      </div>
      <div class="home-container" v-else>
        <component :is="selectedTemplate" :homeImage="homeImage" @exit="exitHomePage"></component>
        <ShowRights v-if="exhibitId" :exhibitId="exhibitId" />

      </div>
    </div>

    <div class="popup">
      <p class="rights-text">{{ rights }}</p>

      <q-dialog v-model="popup" maximized>
        <q-card class="column full-width full-height" :style="getPopupBackgroundStyle">
          <q-btn icon="close" style="position:absolute; top: 6px; left:50px; z-index: 10000;" flat round dense
            :color="navIconColor" @click="closeAllDialogs()" />


          <q-card-section ref="displayContainer" class="col q-pa-none" style="position: relative; overflow: hidden;">
            <div v-for="(block, index) in blocks1" :key="index"
              :style="{ top: (block.top) + 'px', left: block.left + 'px' }" :class="`block  ${index}`">
              <div class="media-container"
                :class="{ 'has-associated': block.associatedResources, 'is-interactive': isInteractiveBlock(block) }"
                :style="{ width: `${block.width}px`, height: `${block.height}px`, position: 'relative' }"
                @click="() => { showStyleComponenent(block, index) }">
                <transition appear :enter-active-class="block.animation">
                  <div v-show="block.animation || block.animation2" :key="index"
                    :class="block.animation2 ? block.animation2 : ''" style="width: 100%; height: 100%">
                    <img v-if="block.animation != 'squareImg' && isImage(block.name)" :src="block.imgSrc"
                      alt="Block Image" class="img" :style="getRotationStyle(block)" />
                    <SquareImg v-else-if="block.animation == 'squareImg' && isImage(block.name)" :blockDatas="block"
                      />
                    <video v-else-if="isVideo(block.name)" :src="block.imgSrc" :style="getRotationStyleVideo(block)"
                      :controls="!isInteractiveBlock(block)" class="video-container"
                      @click.stop="() => { showStyleComponenent(block, index) }"></video>
                    <audio v-else-if="isAudio(block.name)" :src="block.imgSrc" controls></audio>
                    <q-icon v-if="getBlockActionIcon(block) && block.animation != 'squareImg'"
                      class="associated-resources-icon" :name="getBlockActionIcon(block)"
                      :color="isQuizBlock(block) ? 'deep-purple-4' : 'orange'"></q-icon>
                    <div v-if="block.source || block.sourceUrl" class="image-source">
                      <div class="image-source-text"><span v-if="block.source">Source : {{ block.source }}</span> <span
                          v-if='block.sourceUrl'>- Url :{{ block.sourceUrl }}</span></div>
                    </div>
                  </div>
                </transition>
              </div>

            </div>

            <div v-for="(block2, index) in blocks2" :key="index + 100"
              class="block cartel animate__animated animate__zoomIn"
              :style="{ top: (block2.top) + 'px', left: block2.left + 'px' }">
              {{ block2.text }}
            </div>

            <!-- Textes personnalisés -->
            <div v-for="(textBlock, index) in textBlocks" :key="'text-' + index" class="text-block"
              :style="getTextBlockStyle(textBlock)">
              <div v-html="textBlock.content"></div>
            </div>
          </q-card-section>
        </q-card>
        <div v-if="negatifSlider" class="styleElements">
          <NegatifSlider :blockDatas="blockSliderDatas" @closeSlider="closeSlider()"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div v-if="comicOverlay">
          <ComicsOverlay :block="comicsDatas" />
        </div>
        <div>
          <Carousel3D v-if="carousel3D" :blockDatas="blockCarouselDatas" @closeCarousel3D="closeCarousel3D"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <FlipBook v-if="flipBook" :blockDatas="blockSliderDatas" @closeFlipBook="closeFlipBook"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <MusicNotes v-if="musicNotes" />
        </div>
        <div>
          <Scroll v-if="scroll" :blockScrollDatas="blockScrollDatas" @closeScroll="closeScroll"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <VideoComponent v-if="video" :blockVideoDatas="blockVideoDatas" @closeVideo="closeVideo"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <ImageAudio v-if="imageAudio" :blockImageAudioDatas="blockImageAudioDatas" @closeImageAudio="closeImageAudio"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <DocxViewer v-if="docxViewer" :docxResource="blockDocxData" @closeDocxViewer="closeDocxViewer"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <QuizOverlay v-if="quizOverlay" :quizId="quizIdToPlay" @closeQuiz="closeQuizOverlay"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <Diaporama v-if="diaporama" :blockDatas="blockDiaporamaDatas" @closeDiaporama="closeDiaporama"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <Mosaique v-if="mosaique" :blockDatas="blockMosaiqueDatas" @closeMosaique="closeMosaique"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <Pellicule v-if="pellicule" :blockDatas="blockPelliculeDatas" @closePellicule="closePellicule"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <CoverflowCarousel v-if="coverflow" :blockDatas="blockCoverflowDatas" @closeCoverflow="closeCoverflow"
            @closeAllDialogs="closeAllDialogs" />
        </div>
        <div>
          <AvantApres v-if="avantApres" :blockDatas="blockAvantApresDatas" @closeAvantApres="closeAvantApres"
            @closeAllDialogs="closeAllDialogs" />
        </div>
      </q-dialog>
    </div>

  </div>
</template>

<script>
import { ref, onMounted, computed, provide } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import Konva from "konva";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import NegatifSlider from "../../components/NegatifSlider.vue";
import ComicsOverlay from "../../components/ComicsOverlay.vue";
import Carousel3D from "../../components/Carousel3D.vue";
import FlipBook from "../../components/FlipBook.vue";
import SquareImg from "../../components/SquareImg.vue";
import MusicNotes from "../../components/MusicNotes.vue";
import Scroll from "../../components/Scroll.vue";
import VideoComponent from "../../components/Video.vue";
import ShowRights from "../../components/ShowRights.vue";
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";
import ImageAudio from "../../components/ImageAudio.vue";
import DocxViewer from "../../components/DocxViewer.vue";
import QuizOverlay from "../../components/QuizOverlay.vue";
import Diaporama from "../../components/Diaporama.vue";
import Mosaique from "../../components/Mosaique.vue";
import Pellicule from "../../components/Pellicule.vue";
import CoverflowCarousel from "../../components/CoverflowCarousel.vue";
import AvantApres from "../../components/AvantApres.vue";
export default {
  components: {
    NegatifSlider,
    ComicsOverlay,
    Carousel3D,
    FlipBook,
    SquareImg,
    MusicNotes,
    Scroll,
    VideoComponent,
    ShowRights,
    Modele_2,
    Modele_3,
    Modele_1,
    Modele_4,
    Modele_5,
    Modele_6,
    Modele_7,
    ImageAudio,
    QuizOverlay,
    DocxViewer,
    Diaporama,
    Mosaique,
    Pellicule,
    CoverflowCarousel,
    AvantApres,
  },
  props: {
    exhibitIdBis: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const { style: charte, hasStyle: hasCharte, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdBis);
    let exhibitId = ref();
    let backgroundImg = ref();
    let resources = ref();
    let backgroundFile = ref();
    let canvasRef = ref(null);
    let mainResourceId = ref();
    let points = ref([]);
    var stage;
    var layer;
    var circlesLayer;
    let imgWidth = ref();
    let imgHeight = ref();
    let popup = ref(false);
    let blocksDatas = ref();
    let blocks1 = ref([]);
    let blocks2 = ref([]);
    let currentPointId = ref();
    let negatifSlider = ref(false);
    let blockSliderDatas = ref();
    let comicOverlay = ref();
    let carousel3D = ref(false);
    let flipBook = ref(false);
    let squareImg = ref(false);
    let showBlock = ref(true);
    let musicNotes = ref(false);
    let comicsDatas = ref();
    let blockCarouselDatas = ref();
    let scroll = ref(false);
    let blockScrollDatas = ref();
    let homeImage = ref();
    let hasHomeImage = ref(false);
    let homeResource = ref();
    let video = ref(false);
    let blockVideoDatas = ref();
    let animations = ref(false);
    let showBlockDelay = ref(false);
    let mainResource = ref();
    let selectedTemplate = ref();
    let color = ref("#ffffff");
    let imageAudio = ref(false);
    let blockImageAudioDatas = ref();
    let squareImgData = ref();
    let isLoading = ref(false);
    let titleColor = ref();
    let titleSize = ref();
    let textBlocks = ref([]);
    let popupBackgroundImage = ref(null);
    let docxViewer = ref(false);
    let blockDocxData = ref(null);
    let docxDatas = ref();
    let rights = ref('');
    let returnImgSrc = ref(null);
    let overlayBg = ref({ color: null, imageSrc: null });
    let quizOverlay = ref(false);
    let quizIdToPlay = ref(null);
    let diaporama = ref(false);
    let blockDiaporamaDatas = ref();
    let mosaique = ref(false);
    let blockMosaiqueDatas = ref();
    let pellicule = ref(false);
    let blockPelliculeDatas = ref();
    let coverflow = ref(false);
    let blockCoverflowDatas = ref();
    let avantApres = ref(false);
    let blockAvantApresDatas = ref();
    // Lot 4 / C : fournit aux overlays le bouton "retour" personnalisé (icône banque OU image de l'expo)
    provide('returnBtn', {
      icon: computed(() => (homeImage.value && homeImage.value.return_icon) || 'home'),
      img: returnImgSrc,
    });
    // Fond configurable de l'overlay (couleur OU image), par ressource
    provide('overlayBg', overlayBg);
    let displayContainer = ref(null);
    const start = async () => {
      console.log("Exposition lancée : page principale")
      exhibitId.value = route.params.id;
      if (exhibitId.value == undefined) {
        exhibitId.value = props.exhibitIdBis;
      }
      await loadCharte();
      await getMainResource();
      await getResources();
      if (mainResource.value) {
        await getFile(mainResource.value.name);
      }
      await getHomeImage();
      await loadReturnImage();
      await getHomeFile();


      await getAnimations();

      await getModel();
      console.log("test")
      // Sans page d'accueil, rien ne déclenche exitHomePage() : on dessine la navigation directement.
      if (!hasHomeImage.value) await exitHomePage();
    };
    const getResources = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resources`;
        let body = {
          exhibitId: exhibitId.value,
        };
        let response = await axios.post(url, body);
        let results = response.data;

        resources.value = results;
      } catch (error) {
        console.log(error);
      }
    };

    const getFile = async (name) => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
        let response = await axios.get(url);
        backgroundFile.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const getHomeFile = async () => {
      try {
        let name = homeImage.value.name;
        let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
        let response = await axios.get(url);
        var base64data = response.data;
        homeResource.value = base64data;
      } catch (error) {
        console.log(error);
      }
    };

    const showBlockStyle = (block) => {
      blockSliderDatas.value = block
      if (block.style == "comics") {
        comicOverlay.value = true
        comicsDatas.value = block;
      }
    }
    const drawImage = () => {
      return new Promise((resolve, reject) => {
        const imageObj = new Image();
        imageObj.src = backgroundFile.value;

        imageObj.onload = function () {
          // Dimensions de la fenêtre du navigateur (viewport)
          const canvasWidth = window.innerWidth;
          const canvasHeight = window.innerHeight;



          // Si l'image est plus grande que le canvas, ajustez-la
          if (imageObj.width > canvasWidth || imageObj.height > canvasHeight) {
            const scale = Math.min(canvasWidth / imageObj.width, canvasHeight / imageObj.height);
            imgWidth.value = imageObj.width * scale;
            imgHeight.value = imageObj.height * scale;
          } else {
            // Si l'image est plus petite que le canvas, utilisez sa taille d'origine
            imgWidth.value = imageObj.width;
            imgHeight.value = imageObj.height;
          }

          // Positions pour centrer l'image dans le canvas
          const imgX = (canvasWidth - imgWidth.value) / 2;
          const imgY = (canvasHeight - imgHeight.value) / 2;

          // Créer un stage Konva
          stage = new Konva.Stage({
            container: "mainContainer",
            width: canvasWidth,
            height: canvasHeight
          });

          layer = new Konva.Layer();
          stage.add(layer);

          const konvaImage = new Konva.Image({
            x: imgX,
            y: imgY,
            image: imageObj,
            width: imgWidth.value,
            height: imgHeight.value
          });

          layer.add(konvaImage);
          layer.draw();

          resolve(); // Résoudre la promesse lorsque l'image a fini de charger
        };

        imageObj.onerror = function () {
          reject(new Error("Erreur lors du chargement de l'image"));
        };
      });
    };



    const getRotationStyle = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        boxShadow: block.boxShadow,
        cursor: isInteractiveBlock(block) ? 'pointer' : 'default'

      };
    };

    const isQuizBlock = (block) => ["quiz", "quizFullPage"].includes(block?.style) && !!block?.quiz_id;

    const isInteractiveBlock = (block) => {
      return !!(
        block?.associatedResources ||
        block?.style === "link" ||
        isQuizBlock(block)
      );
    };

    const getBlockActionIcon = (block) => {
      if (isQuizBlock(block)) return "quiz";
      if (block?.style === "link") return "link";
      if (block?.associatedResources) return "new_releases";
      return null;
    };

    const getHomeImage = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${exhibitId.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          hasHomeImage.value = true;
        }
        homeImage.value = response.data[0];
      } catch (error) {
        console.log(error)
      }
    }

    const getModel = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${exhibitId.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          selectedTemplate.value = response.data[0].model;
          selectedTemplate.value = selectedTemplate.value.replace(/è/g, 'e').replace(/\s+/g, '_');
        }
      } catch (error) {
        console.log(error);
      }
    }

    const getMainResource = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/mainResource/${exhibitId.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          mainResourceId.value = response.data[0].main_resource_id;
          mainResource.value = response.data[0];
        }

      } catch (error) {
        console.log(error)
      }
    }


    // Créez un champ pour stocker la source du token d'annulation courant
    let cancelSource;

    const getResourcesFromPoint = async () => {
      try {
        // Si un token d'annulation existe déjà (ce qui signifie qu'une requête est en cours), annulez cette requête
        if (cancelSource) {
          cancelSource.cancel("Previous request cancelled due to new request");
        }

        // Créez une nouvelle source de token d'annulation
        cancelSource = axios.CancelToken.source();

        let url = `${process.env.VUE_APP_BASEURL}/resourcesFromPointWithAssociations/${currentPointId.value}`;
        let response = await axios.get(url, {
          cancelToken: cancelSource.token // Passez le cancelToken ici
        });

        blocksDatas.value = response.data;
        await loadSavedTexts();
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request was cancelled:', error.message);
        } else {
          console.log(error);
        }
      }
    };


    const exitHomePage = async () => {
      hasHomeImage.value = false;
      await drawImage();
      await getPoints();
      setTimeout(async () => {
        await showPoints();
      }, 1000)
    }

    function computeMargins() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const marginLeft = (windowWidth - 1400) / 2;
      const marginTop = ((windowHeight - 1200) / 2);

      return { marginLeft, marginTop };
    }

    let cancelSources = [];

    const cancelAllPendingRequests = () => {
      for (const source of cancelSources) {
        source.cancel("Cancelled due to new interaction");
      }
      cancelSources.length = 0;
    };

    const showBlocks = async () => {
      try {
        const { marginLeft, marginTop } = computeMargins();
        console.log("marginLeft", marginLeft);
        console.log("marginTop", marginTop);
        blocks1.value.splice(0);
        blocks2.value.length = 0;
        console.log("blocksDatas.value", blocksDatas.value);

        // Dimensions de référence du design original
        const REFERENCE_WIDTH = 1400;
        const REFERENCE_HEIGHT = 760;

        const container = displayContainer.value?.$el || displayContainer.value;
        const containerW = container?.clientWidth || window.innerWidth;
        const containerH = container?.clientHeight || window.innerHeight;

        for (var data of blocksDatas.value) {
          let source = axios.CancelToken.source();
          cancelSources.push(source);
          let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${data.name}`;
          let response = await axios.get(url, { cancelToken: source.token });
          const base64data = response.data;
          source = axios.CancelToken.source();
          cancelSources.push(source);
          let url2 = `${process.env.VUE_APP_BASEURL}/position/${data.resource_id}`;
          let response2 = await axios.get(url2, { cancelToken: source.token });
          if (response2.data.length > 1) {
            response2.data = response2.data.filter(element => element.point_id == currentPointId.value)
          }
          source = axios.CancelToken.source();
          cancelSources.push(source);
          let url3 = `${process.env.VUE_APP_BASEURL}/style/${data.resource_id}/${data.point_id}`;
          let response3 = await axios.get(url3, { cancelToken: source.token });
          let style = response3.data[0] ? response3.data[0].style : null;
          var obj = {};
          obj.resourceId = data.resource_id;
          obj.name = data.name;
          obj.bg_color = response3.data[0] ? response3.data[0].bg_color : null;
          obj.bg_image_id = response3.data[0] ? response3.data[0].bg_image_id : null;
          obj.quiz_id = response3.data[0] ? response3.data[0].quiz_id : null;
          console.log("response2.data", response2.data);

          // Facteur d'échelle global pour adapter à la taille actuelle du conteneur
          const windowScaleFactor = Math.min(
            containerW / REFERENCE_WIDTH,
            containerH / REFERENCE_HEIGHT
          );

          if (response2.data && response2.data[0]) {
            // Si nous avons des données de position, calculer avec des facteurs d'échelle
            // Position en pourcentage de la référence
            const relativeX = response2.data[0].x / REFERENCE_WIDTH;
            const relativeY = response2.data[0].y / REFERENCE_HEIGHT;
            console.log("relativeX", relativeX);
            console.log("relativeY", relativeY);
            // Convertir en pixels pour le conteneur actuel
            obj.left = relativeX * containerW;
            obj.top = relativeY * containerH;

            // Dimensions proportionnelles
            if (response2.data[0].width && response2.data[0].height) {
              obj.width = (response2.data[0].width / REFERENCE_WIDTH) * containerW;
              obj.height = (response2.data[0].height / REFERENCE_HEIGHT) * containerH;
            } else {
              // Valeurs par défaut raisonnables si les dimensions sont manquantes
              obj.width = 300 * windowScaleFactor;
              obj.height = 200 * windowScaleFactor;
            }
          } else {
            // Valeurs par défaut pour les nouveaux blocs
            obj.left = (containerW - 300 * windowScaleFactor) / 2;
            obj.top = (containerH - 200 * windowScaleFactor) / 2;
            obj.width = 300 * windowScaleFactor;
            obj.height = 200 * windowScaleFactor;
          }

          obj.imgSrc = base64data;
          obj.source = data.source;
          obj.sourceUrl = data.source_url;
          obj.associatedResources = data.associatedResources;
          obj.style = style;
          obj.angle = response2.data[0] ? response2.data[0].angle : 0;
          obj.radius = response2.data[0] ? response2.data[0].border_radius : 10;
          obj.borderColor = response2.data[0] ? response2.data[0].border_color : "#ffffff";
          obj.borderWidth = response2.data[0] ? response2.data[0].border_width : 2;
          obj.boxShadow = response2.data[0] ? response2.data[0].shadow : "0px 0px 0px #000000";
          obj.title = data.title;
          console.log("obj", obj);
          blocks1.value.push(obj);
        }
        for (var data2 of blocksDatas.value) {
          let url3 = `${process.env.VUE_APP_BASEURL}/position/${data2.resource_id}`;
          let response3 = await axios.get(url3);
          if (response3.data.length > 1) {
            response3.data = response3.data.filter(element => element.point_id == currentPointId.value)
          }

          if (response3.data && response3.data[0]) {
            var obj2 = {};
            obj2.resourceId = response3.data[0].resource_id;

            // Calculer les positions pour les textes de la même façon
            const relativeDescX = response3.data[0].description_x / REFERENCE_WIDTH;
            const relativeDescY = response3.data[0].description_y / REFERENCE_HEIGHT;

            obj2.left = relativeDescX * containerW;
            obj2.top = relativeDescY * containerH + 350;
            obj2.text = response3.data[0].description;

            if (obj2.text != null && obj2.text != undefined && obj2.text != "" && obj2.text != "undefined") {
              blocks2.value.push(obj2);
            }
          }
        }
        showAnimations();

        blocks1.value.map(block => {
          showBlockStyle(block)

        })
      } catch (error) {
        console.log(error);
      }
    };

    circlesLayer = new Konva.Layer();

    const showPoints = async () => {

      const loadImage = (imageUrl) => {
        return new Promise((resolve, reject) => {
          const imageObj = new Image();
          imageObj.onload = () => resolve(imageObj);
          imageObj.onerror = reject;
          imageObj.src = imageUrl;
        });
      };

      const FIXED_CANVAS_WIDTH = 500;
      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      const imgAdminWidth = FIXED_CANVAS_WIDTH;
      const imgAdminHeight = imgAdminWidth * (imgHeight.value / imgWidth.value);
      var offsetX = 0;
      var offsetY = 0;

      if (imgWidth.value < windowWidth) {
        offsetX = (window.innerWidth - imgWidth.value) / 2;
      }
      if (imgHeight.value < windowHeight) {
        offsetY = (window.innerHeight - imgHeight.value) / 2;
      }

      const scaleFactorX = imgWidth.value / imgAdminWidth;
      const scaleFactorY = imgHeight.value / imgAdminHeight;

      let promises = points.value.map(async (point) => {

        const x_new = (point.x * scaleFactorX) + offsetX;
        const y_new = (point.y * scaleFactorY) + offsetY;
        let imageObjForCircle = null;

        if (point.resource_id) {
          let url = `${process.env.VUE_APP_BASEURL}/resourceData/${point.resource_id}`;
          let response = await axios.get(url);
          let url2 = `${process.env.VUE_APP_BASEURL}/s3Resource/${response.data[0].name}`;
          let response2 = await axios.get(url2);
          const imageUrl = response2.data;
          const imageObj = await loadImage(imageUrl);

          var imageX = x_new;
          var imageY = y_new;
          const halfImageWidth = 30;
          const halfImageHeight = 30;

          switch (point.image_position) {
            case 'top':
              imageY = y_new - point.size - (halfImageHeight * 2) - 20;
              imageX -= halfImageWidth;
              break;
            case 'right':
              imageX = x_new + point.size + 15;
              imageY -= halfImageHeight;
              break;
            case 'bottom':
              imageY = y_new + point.size + 15;
              imageX -= halfImageWidth;
              break;
            case 'left':
              imageX = x_new - point.size - (halfImageWidth * 2) - 15;
              imageY -= halfImageHeight;
              break;
            case 'inside':
              imageObjForCircle = imageObj;
              break;
          }


          if (point.image_position !== 'inside') {
            const maxDimImg = 60;
            const imgRatio = imageObj.width / imageObj.height;
            const imgW = imgRatio >= 1 ? maxDimImg : maxDimImg * imgRatio;
            const imgH = imgRatio >= 1 ? maxDimImg / imgRatio : maxDimImg;
            const konvaImage = new Konva.Image({
              x: imageX,
              y: imageY,
              image: imageObj,
              width: imgW,
              height: imgH,
              stroke: 'white',
              strokeWidth: 2,
              shadowColor: 'black',
              shadowBlur: 10,
              shadowOffsetX: 3,
              shadowOffsetY: 3,
              shadowOpacity: 0.6,
              filters: [Konva.Filters.Contrast],
              contrast: 10
            });

            layer.add(konvaImage);
            layer.draw();
          }
        }
        let textWidth = estimateTextWidth(point.name, 20, 'Arial');

        var textX = x_new - (textWidth / 2); // Centrer horizontalement
        var textY = y_new - point.size - 25;

        var text = new Konva.Text({
          x: textX,
          y: textY,
          text: point.name,
          fontSize: 20,
          fontFamily: 'Arial',
          fill: 'white',
          shadowColor: 'black',
          shadowBlur: 4,
          shadowOffsetX: 2,
          shadowOffsetY: 2,
          shadowOpacity: 0.7,
          align: 'center'
        });

        if (point.visibility) {
          layer.add(text);
        }

        addCircle(x_new, y_new, point.point_id, point.size, point.color, imageObjForCircle, point.shape, point.shape_image_id, point.hover_animation);
      });

      await Promise.all(promises);
      stage.add(circlesLayer);
      circlesLayer.draw();
      circlesLayer.moveToTop();

    };


    const estimateTextWidth = (text, fontSize, fontFamily) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px ${fontFamily}`;
      return ctx.measureText(text).width;
    };


    const addCircle = (x, y, pointId, size, color, imageObj, pointShape, shapeImageId, hoverAnimation) => {
      const currentShape = pointShape || 'circle';
      let shapeNode;
      // B : effet de relief au survol (grandissement + ombre), optionnel par point
      const addLift = (node) => {
        if (!hoverAnimation) return;
        // Grandissement au survol uniquement (pas d'ombre Konva sur image : elle laisse une bande qui ne s'efface pas)
        node.on('mouseenter', () => {
          node.moveToTop();
          node.to({ scaleX: 1.18, scaleY: 1.18, duration: 0.12 });
        });
        node.on('mouseout', () => {
          node.to({ scaleX: 1, scaleY: 1, duration: 0.12 });
        });
      };

      if (currentShape === 'square') {
        const rectConfig = {
          x: x - size,
          y: y - size,
          width: size * 2,
          height: size * 2,
          fill: imageObj ? null : color,
          stroke: "#ffffff",
          strokeWidth: 3,
          shadowColor: 'rgba(0, 0, 0, 0.3)',
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          shadowOpacity: 1,
        };
        if (imageObj) {
          const scale = (size * 2) / Math.max(imageObj.width, imageObj.height);
          rectConfig.fillPatternImage = imageObj;
          rectConfig.fillPatternScaleX = scale;
          rectConfig.fillPatternScaleY = scale;
          rectConfig.fillPatternOffset = { x: imageObj.width / 2, y: imageObj.height / 2 };
          rectConfig.fillPatternRepeat = 'no-repeat';
          const colorRect = new Konva.Rect({
            x: x - size,
            y: y - size,
            width: size * 2,
            height: size * 2,
            fill: color
          });
          circlesLayer.add(colorRect);
        }
        shapeNode = new Konva.Rect(rectConfig);
      } else if (currentShape === 'image') {
        const maxDim = size * 2;

        const handleImgInteraction = async () => {
          cancelAllPendingRequests();
          isLoading.value = true;
          currentPointId.value = pointId;
          popup.value = true;
          await fetchPointColors();
          await getResourcesFromPoint();
          await showBlocks();
          await loadPopupBackgroundImage();
          isLoading.value = false;
        };

        if (shapeImageId) {
          const loadShapeImage = async () => {
            let url = `${process.env.VUE_APP_BASEURL}/resourceData/${shapeImageId}`;
            let response = await axios.get(url);
            let url2 = `${process.env.VUE_APP_BASEURL}/s3Resource/${response.data[0].name}`;
            let response2 = await axios.get(url2);
            const shapeImgObj = await new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => resolve(img);
              img.onerror = reject;
              img.src = response2.data;
            });
            const ratio = shapeImgObj.width / shapeImgObj.height;
            let w, h;
            if (ratio >= 1) { w = maxDim; h = maxDim / ratio; }
            else { h = maxDim; w = maxDim * ratio; }
            shapeNode = new Konva.Image({
              x: x,
              y: y,
              offsetX: w / 2,
              offsetY: h / 2,
              image: shapeImgObj,
              width: w,
              height: h,
            });
            circlesLayer.add(shapeNode);
            shapeNode.on('mouseenter', () => {
              stage.container().style.cursor = 'pointer';
            });
            shapeNode.on('mouseout', () => {
              stage.container().style.cursor = 'default';
            });
            shapeNode.on("click", handleImgInteraction);
            shapeNode.on("tap", handleImgInteraction);
            addLift(shapeNode);
            shapeNode.moveToTop();
            circlesLayer.draw();
          };
          loadShapeImage();
        }
        return;
      } else {
        // Default: circle
        const circleConfig = {
          x: x,
          y: y,
          radius: size,
          fill: imageObj ? null : color,
          stroke: "#ffffff",
          strokeWidth: 3,
          shadowColor: 'rgba(0, 0, 0, 0.3)',
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          shadowOpacity: 1,
        };
        if (imageObj) {
          const scale = (size * 2) / Math.max(imageObj.width, imageObj.height);
          circleConfig.fillPatternImage = imageObj;
          circleConfig.fillPatternScaleX = scale;
          circleConfig.fillPatternScaleY = scale;
          circleConfig.fillPatternOffset = { x: imageObj.width / 2, y: imageObj.height / 2 };
          circleConfig.fillPatternRepeat = 'no-repeat';
          const colorCircle = new Konva.Circle({
            x: x,
            y: y,
            radius: size,
            fill: color
          });
          circlesLayer.add(colorCircle);
        }
        shapeNode = new Konva.Circle(circleConfig);
      }

      circlesLayer.add(shapeNode);
      stage.add(circlesLayer);

      // Fonction pour gérer les interactions
      const handleInteraction = async () => {
        cancelAllPendingRequests();

        isLoading.value = true;
        currentPointId.value = pointId;
        popup.value = true;
        await fetchPointColors();
        await getResourcesFromPoint();
        await showBlocks();
        await loadPopupBackgroundImage(); // Charger l'image de fond du popup
        isLoading.value = false;
      };

      // Ajout des gestionnaires d'événements pour les clics et les appuis
      shapeNode.on('mouseenter', () => {
        stage.container().style.cursor = 'pointer';
      });

      shapeNode.on('mouseout', () => {
        stage.container().style.cursor = 'default';
      });

      // Ajout des gestionnaires d'événements pour les clics et les appuis
      shapeNode.on("click", handleInteraction);
      shapeNode.on("tap", handleInteraction);
      addLift(shapeNode);
      shapeNode.moveToTop();

    };
    const getPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/points/${mainResourceId.value}`;
        let response = await axios.get(url);
        points.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const showStyleComponenent = (block, index) => {
      if (!isInteractiveBlock(block)) return;
      overlayBg.value = { color: block.bg_color || null, imageSrc: null };
      if (block.bg_image_id) loadOverlayBgImage(block.bg_image_id);

      if (block.associatedResources && block.style == "negatifSlider") {
        negatifSlider.value = true;
      }
      if (block.associatedResources && block.style == "carousel3D") {
        carousel3D.value = true;
        blockCarouselDatas.value = block
      }
      if (block.associatedResources && block.style == "scroll") {
        scroll.value = true;
        blockScrollDatas.value = block
      }
      if (block.associatedResources && block.style == "flipBook") {
        flipBook.value = true;
      }
      if (block.associatedResources && block.style == "video") {
        video.value = true;
        blockVideoDatas.value = block
      }
      if (block.associatedResources && block.style == "imageAudio") {
        imageAudio.value = true;
        blockImageAudioDatas.value = block
      }
      if (block.associatedResources && block.style == "diaporama") {
        diaporama.value = true;
        blockDiaporamaDatas.value = block
      }
      if (block.associatedResources && block.style == "mosaique") {
        mosaique.value = true;
        blockMosaiqueDatas.value = block
      }
      if (block.associatedResources && block.style == "pellicule") {
        pellicule.value = true;
        blockPelliculeDatas.value = block
      }
      if (block.associatedResources && block.style == "coverflow") {
        coverflow.value = true;
        blockCoverflowDatas.value = block
      }
      if (block.associatedResources && block.style == "avantApres") {
        avantApres.value = true;
        blockAvantApresDatas.value = block
      }
      if (block.associatedResources && block.style == "docx") {
        blockDocxData.value = block;
        docxViewer.value = true;
      }
      if (block.style == "link") {
        addLinkToBlock(block, index)
      }
      if (block.style == "quiz" && block.quiz_id) {
        quizIdToPlay.value = block.quiz_id;
        quizOverlay.value = true;
      }
      if (block.style == "quizFullPage" && block.quiz_id) {
        // Pleine page = nouvel onglet (l'overlay "quiz" reste dans l'app, lui)
        // `retour` : l'exposition d'où l'on vient, pour que le bouton de retour
        // du quiz sache où aller si l'onglet ne peut pas être refermé.
        const href = router.resolve({
          name: "Quiz",
          params: { id: block.quiz_id },
          query: { retour: route.fullPath },
        }).href;
        window.open(href, "_blank");
      }

      blockSliderDatas.value = block;


    }

    const addLinkToBlock = (block, index) => {
      // Récupération du block
      let blocks = document.querySelectorAll(".block"); // utilisation de querySelectorAll au lieu de getElementsByClassName
      let selectedBlock = blocks[index];

      // Récupérer l'URL depuis le titre
      let matches = block.title.match(/\[(.*?)\]/);
      if (matches) {
        let url = matches[1];

        // Assigner l'URL au bloc et le rendre cliquable
        selectedBlock.style.cursor = "pointer";
        selectedBlock.addEventListener("click", () => {
          window.open(url, "_blank"); // ouvrez le lien dans un nouvel onglet
        });
      }
    }



    const showAnimations = async () => {
      let newBlocks1 = [...blocks1.value]; // Création d'une nouvelle instance du tableau
      for (let block of newBlocks1) {
        if (Array.isArray(animations.value) && animations.value.some(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value)) {
          let animation = animations.value.find(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value)
          let animationString;
          if (animation.animation === "spin" || animation.animation === "slide" || animation.animation === "pulse" || animation.animation === "swingRotate" || animation.animation === "verticalBounce") {
            block['animation2'] = animation.animation
          } else if (animation.animation == "squareImg") {
            block['animation'] = "squareImg";
            block['animationSpeed'] = animation.speed || "";
            block['animationDelay'] = animation.delay || "";
          } else if (animation.animation == "musicNote") {
            musicNotes.value = true
            block['animation'] = "musicNote";
          } else {
            animationString = 'animate__animated animate__' + animation.animation;

            // Ajout de la classe de vitesse si elle existe
            if (animation.speed && animation.speed.trim() !== '') {
              animationString += " " + animation.speed;
            } else {
              // Valeur par défaut si aucune vitesse n'est spécifiée
              animationString += " animate__slower";
            }

            // Ajout de la classe de délai si elle existe
            if (animation.delay && animation.delay.trim() !== '') {
              animationString += " " + animation.delay;
            }

            block['animation'] = animationString;
          }
        } else {
          block['animation'] = 'animate__animated animate__zoomIn';
        }
      }
      blocks1.value = newBlocks1; // Assignation du nouveau tableau à blocks1.value
    }


    const closeAll = () => {
      console.log("closeAll");
      comicOverlay.value = false;
      squareImg.value = false;
      musicNotes.value = false;
      blocks1.value.splice(0);
      blocks2.value = [];
      textBlocks.value = [];
      docxViewer.value = false;
      carousel3D.value = false;
      blocksDatas.value = {};
      popupBackgroundImage.value = null;
      color.value = '#ffffff';
      popup.value = false;
    }

    const closeDocx = () => {
      docxViewer.value = false;
    }

    const closeImageAudio = () => {
      imageAudio.value = false;
    }

    const closeCarousel3D = () => {
      carousel3D.value = false;
    }

    const closeDiaporama = () => {
      diaporama.value = false;
    }

    const closeMosaique = () => {
      mosaique.value = false;
    }

    const closePellicule = () => {
      pellicule.value = false;
    }

    const closeCoverflow = () => {
      coverflow.value = false;
    }

    const closeAvantApres = () => {
      avantApres.value = false;
    }

    const closeAllDialogs = () => {
      console.log("closeAllDialogs");
      closeCarousel3D();
      closeSlider();
      closeScroll();
      closeFlipBook();
      closeVideo();
      closeImageAudio();
      closeDocx();
      closeSquareImg();
      closeMusicNotes();
      closeQuizOverlay();
      closeDiaporama();
      closeMosaique();
      closePellicule();
      closeCoverflow();
      closeAvantApres();
      blocksDatas.value = {};
      popupBackgroundImage.value = null;
      color.value = '#ffffff';
      popup.value = false;
    }

    const closeSquareImg = () => {
      squareImg.value = false;
    }

    const closeQuizOverlay = () => {
      quizOverlay.value = false;
    }

    const closeMusicNotes = () => {
      musicNotes.value = false;
    }

    const closeSlider = () => {
      negatifSlider.value = false;
    }

    const closeScroll = () => {
      scroll.value = false
    }

    const closeFlipBook = () => {
      flipBook.value = false;
    }

    const closeVideo = () => {
      video.value = false;
      blockVideoDatas.value = {};
    }

    function isImage(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }

    function isVideo(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp4", "webm", "avi", "mov", "mkv"].includes(extension);
    }

    function isAudio(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp3", "wav", "ogg", "m4a"].includes(extension);
    }

    const getAnimations = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resource_animation/${exhibitId.value}`;
        let response = await axios.get(url);
        animations.value = response.data;

        // Transformation pour s'assurer que les données speed et delay sont accessibles
        if (animations.value && animations.value.length > 0) {
          animations.value = animations.value.map(animation => {
            // Si les colonnes speed et delay existent, on les utilise directement
            if (!animation.speed && animation.animation_speed) {
              animation.speed = animation.animation_speed;
            }
            if (!animation.delay && animation.animation_delay) {
              animation.delay = animation.animation_delay;
            }
            return animation;
          });
        }

      } catch (error) {
        console.log(error);
      }
    }

    const loadReturnImage = async () => {
      const id = homeImage.value && homeImage.value.return_image_id;
      if (!id) { returnImgSrc.value = null; return; }
      try {
        const r1 = await axios.get(`${process.env.VUE_APP_BASEURL}/resourceData/${id}`);
        const name = r1.data && r1.data[0] && r1.data[0].name;
        if (!name) return;
        const r2 = await axios.get(`${process.env.VUE_APP_BASEURL}/s3Resource/${name}`);
        returnImgSrc.value = r2.data;
      } catch (e) { console.log('loadReturnImage', e); }
    };

    const loadOverlayBgImage = async (id) => {
      if (!id) return;
      try {
        const r1 = await axios.get(`${process.env.VUE_APP_BASEURL}/resourceData/${id}`);
        const name = r1.data && r1.data[0] && r1.data[0].name;
        if (!name) return;
        const r2 = await axios.get(`${process.env.VUE_APP_BASEURL}/s3Resource/${name}`);
        overlayBg.value = { ...overlayBg.value, imageSrc: r2.data };
      } catch (e) { console.log('loadOverlayBgImage', e); }
    };

    const fetchPointColors = async () => {
      const fallbackBg = hasCharte.value ? charte.value.bg_color : '#ffffff';
      try {
        let url = `${process.env.VUE_APP_BASEURL}/intermediateColor/${currentPointId.value}`;
        let response = await axios.get(url);
        color.value = response.data[0].background_color || fallbackBg;
        titleColor.value = response.data[0].text_color;
        titleSize.value = response.data[0].text_size;
      } catch (error) {
        console.log(error);
        color.value = fallbackBg;
      }
    }

    const returnToBegin = () => {
      hasHomeImage.value = true;
      router.go(0);
    }

    const getRotationStyleVideo = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        objectFit: 'contain',
        width: `${block.width}px`,
        height: `${block.height}px`,
        boxShadow: block.boxShadow,

      };
    };

    const getTitleStyle = () => {
      return {
        width: '100%',
        marginBottom: 'none',
        textAlign: 'center',
        color: titleColor.value,
        fontSize: titleSize.value + "px",
        marginTop: '1%',
      }
    }

    // Charger les textes enregistrés pour ce point
    const loadSavedTexts = async () => {
      try {
        // Utiliser l'endpoint existant pour récupérer les textes par point_id
        const url = `${process.env.VUE_APP_BASEURL}/custom-texts/point/${currentPointId.value}`;
        const source = axios.CancelToken.source();
        cancelSources.push(source);

        const response = await axios.get(url, {
          cancelToken: source.token
        });

        if (response.data && response.data.length) {
          // Transformer les données reçues au format utilisé par le composant
          textBlocks.value = response.data.map(text => ({
            id: text.id,
            content: text.content,
            top: text.position_top,
            left: text.position_left,
            width: text.width,
            height: text.height,
            fontFamily: text.font_family,
            fontSize: text.font_size,
            color: text.color,
            backgroundColor: text.background_color,
            borderWidth: text.border_width,
            borderStyle: text.border_style,
            borderColor: text.border_color,
            borderRadius: text.border_radius,
            boxShadow: text.box_shadow
          }));
        } else {
          textBlocks.value = [];
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request was cancelled:', error.message);
        } else {
          console.log(error);
        }
      }
    };

    const getTextBlockStyle = (block) => {
      // Dimensions de référence du design original (cohérent avec l'éditeur)
      const REFERENCE_WIDTH = 1400;
      const REFERENCE_HEIGHT = 760;

      const container = displayContainer.value?.$el || displayContainer.value;
      const containerW = container?.clientWidth || window.innerWidth;
      const containerH = container?.clientHeight || window.innerHeight;

      const scaledLeft = block.left * (containerW / REFERENCE_WIDTH);
      const scaledTop = block.top * (containerH / REFERENCE_HEIGHT);
      console.log("scaledLeft", scaledLeft);
      console.log("scaledTop", scaledTop);
      return {
        position: 'absolute',
        top: scaledTop + 'px',
        left: scaledLeft + 'px',
        width: block.width + 'px',
        height: block.height + 'px',
        fontFamily: block.fontFamily || (hasCharte.value ? charte.value.text_font : 'Arial'),
        fontSize: (block.fontSize || (hasCharte.value ? charte.value.text_size : 16)) + 'px',
        color: block.color || (hasCharte.value ? charte.value.text_color : '#000000'),
        backgroundColor: block.backgroundColor || 'transparent',
        padding: '10px',
        borderWidth: (block.borderWidth || 0) + 'px',
        borderStyle: block.borderStyle || 'solid',
        borderColor: block.borderColor || 'transparent',
        borderRadius: (block.borderRadius || 0) + 'px',
        boxShadow: block.boxShadow || 'none',
        maxWidth: (containerW * 0.6) + 'px'
      };
    };

    // Fonction utilitaire pour déterminer la couleur de contraste
    // Parse n'importe quel format CSS (hex, rgb, rgba, nommé) via un canvas caché
    const parseColorToRGB = (colorStr) => {
      if (!colorStr) return { r: 255, g: 255, b: 255 };
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.fillStyle = colorStr;
      // ctx.fillStyle normalise la couleur en format hex #rrggbb
      const normalized = ctx.fillStyle;
      if (normalized.startsWith('#')) {
        const hex = normalized.replace('#', '');
        return {
          r: parseInt(hex.substring(0, 2), 16),
          g: parseInt(hex.substring(2, 4), 16),
          b: parseInt(hex.substring(4, 6), 16)
        };
      }
      // Fallback pour rgb()/rgba()
      const match = normalized.match(/\d+/g);
      if (match && match.length >= 3) {
        return { r: parseInt(match[0]), g: parseInt(match[1]), b: parseInt(match[2]) };
      }
      return { r: 255, g: 255, b: 255 };
    };

    const getContrastColor = (colorStr) => {
      const { r, g, b } = parseColorToRGB(colorStr);
      // Conversion sRGB → linéaire puis luminance W3C
      const rN = r / 255, gN = g / 255, bN = b / 255;
      const rLin = rN <= 0.03928 ? rN / 12.92 : Math.pow((rN + 0.055) / 1.055, 2.4);
      const gLin = gN <= 0.03928 ? gN / 12.92 : Math.pow((gN + 0.055) / 1.055, 2.4);
      const bLin = bN <= 0.03928 ? bN / 12.92 : Math.pow((bN + 0.055) / 1.055, 2.4);
      const luminance = 0.2126 * rLin + 0.7152 * gLin + 0.0722 * bLin;
      return luminance < 0.5 ? 'white' : 'black';
    };

    const navIconColor = computed(() => getContrastColor(color.value));

    const getPopupBackgroundStyle = computed(() => {
      const style = {
        backgroundColor: color.value
      };

      if (popupBackgroundImage.value) {
        style.backgroundImage = `url(${popupBackgroundImage.value})`;
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        // Ajouter un petit overlay pour améliorer la lisibilité du contenu
        style.boxShadow = 'inset 0 0 0 2000px rgba(255, 255, 255, 0.3)';
      } else {
        style.backgroundImage = 'none';
      }

      return style;
    });

    // Fonction pour charger l'image de fond du popup
    const loadPopupBackgroundImage = async () => {
      try {
        const url = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/point/${currentPointId.value}`;
        const response = await axios.get(url);

        // Extraire l'ID de la ressource à partir de la réponse
        const resourceId = response.data?.resource_id ||
          response.data?.background_image_id ||
          (response.data[0] ? response.data[0].resource_id : null);

        if (resourceId) {
          // Chercher la ressource correspondante
          const resourceUrl = `${process.env.VUE_APP_BASEURL}/resourceData/${resourceId}`;
          const resourceResponse = await axios.get(resourceUrl);

          if (resourceResponse.data && resourceResponse.data.length > 0) {
            const resource = resourceResponse.data[0];

            // Charger l'image
            const imageUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
            const imageResponse = await axios.get(imageUrl);

            // Appliquer l'image de fond
            popupBackgroundImage.value = imageResponse.data;
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.log('Aucune image de fond configurée pour ce point');
        } else {
          console.error('Erreur lors du chargement de l\'image de fond du popup:', error);
        }
      }
    };

    const closeDocxViewer = () => {
      docxViewer.value = false;
      blockDocxData.value = null;
    };

    onMounted(start);
    return {
      exhibitId,
      backgroundImg,
      resources,
      backgroundFile,
      canvasRef,
      mainResourceId,
      imgWidth,
      imgHeight,
      popup,
      negatifSlider,
      blockSliderDatas,
      comicOverlay,
      carousel3D,
      flipBook,
      squareImg,
      points,
      showBlock,
      musicNotes,
      comicsDatas,
      blockCarouselDatas,
      blockScrollDatas,
      scroll,
      homeImage,
      hasHomeImage,
      homeResource,
      video,
      blockVideoDatas,
      animations,
      showBlockDelay,
      imageAudio,
      blockImageAudioDatas,
      squareImgData,
      isLoading,
      textBlocks,
      start,
      getResources,
      getFile,
      drawImage,
      getPoints,
      showPoints,
      getResourcesFromPoint,
      blocksDatas,
      showBlocks,
      blocks1,
      blocks2,
      currentPointId,
      selectedTemplate,
      color,
      showStyleComponenent,
      closeCarousel3D,
      closeFlipBook,
      isImage,
      isVideo,
      isAudio,
      closeScroll,
      closeAll,
      closeSlider,
      getHomeImage,
      exitHomePage,
      closeVideo,
      getAnimations,
      showAnimations,
      closeAllDialogs,
      quizOverlay,
      quizIdToPlay,
      closeQuizOverlay,
      diaporama,
      blockDiaporamaDatas,
      closeDiaporama,
      mosaique,
      blockMosaiqueDatas,
      closeMosaique,
      pellicule,
      blockPelliculeDatas,
      closePellicule,
      coverflow,
      blockCoverflowDatas,
      closeCoverflow,
      avantApres,
      blockAvantApresDatas,
      closeAvantApres,
      returnToBegin,
      closeImageAudio,
      getRotationStyle,
      getRotationStyleVideo,
      isInteractiveBlock,
      isQuizBlock,
      getBlockActionIcon,
      getTitleStyle,
      getTextBlockStyle,
      navIconColor,
      getPopupBackgroundStyle,
      returnImgSrc,
      loadPopupBackgroundImage,
      docxViewer,
      blockDocxData,
      closeDocxViewer,
      docxDatas,
      rights,
      displayContainer
    };
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

.cartel {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.cartel h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: #333;
}

.cartel p {
  margin-bottom: 15px;
}

.cartel a {
  color: #1a73e8;
  text-decoration: none;
  font-weight: 500;
}

.cartel a:hover {
  text-decoration: underline;
}

.mainContainer {
  width: 100%;
  height: 100vh;
}

canvas {
  width: 100%;
  height: 100%;
  /* Ajustez la hauteur ici */
  object-fit: contain;
}

.block {
  position: absolute;
}

.styleElements {
  position: absolute;
  top: 30%;
  z-index: 9999;
}


.img {
  width: 100%;
  height: auto;
  max-width: 100vw;
  border-radius: 10px;
  border: 2px solid #f0f0f0;
  transition: filter .15s ease;
}

/* Lot 4 / B : petite animation au survol d'une ressource.
   filter (pas transform) => pas de conflit avec la rotation des blocs ;
   drop-shadow épouse le média réel (pas la box) ; aucun changement de taille => pas de débordement. */
.img:hover,
.video-container:hover {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5)) brightness(1.05);
}

.video-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  max-width: 100%;
  background-color: #000;
  transition: filter .15s ease;
}

home-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f2f2f2;
  /* couleur de fond pour le cas où l'image n'est pas définie */
}

.homeText {
  text-align: center;
  margin-bottom: 30px;
}

.homeText h1 {
  font-size: 36px;
  color: #333;
  /* ajuster la couleur de texte selon les besoins */
  margin: 0;
}

.homeImage {
  width: 100%;
  max-width: 800px;
  /* ajuster la largeur maximale de l'image selon les besoins */
  margin-bottom: 30px;
  margin: auto;
}

.homeImage img {
  display: block;
  width: 80%;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.home-arrow {
  font-size: 30px;
  color: #333;
  /* ajuster la couleur de texte selon les besoins */
  cursor: pointer;
  text-align: right;
  margin-right: 50px;
  animation-name: moveArrow;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes moveArrow {
  from {
    transform: translateX(-10px);
  }

  to {
    transform: translateX(10px);
  }
}

.associated-resources-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 24px;
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
}

.media-container.is-interactive {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.media-container.is-interactive:hover .img,
.media-container.is-interactive:hover .video-container {
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.55)) brightness(1.07);
}

.custom-cursor {
  cursor: pointer;
}

.image-source {
  position: absolute;
  bottom: -22px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  font-size: 8px;
  color: #fff;
  border-radius: 5px;
}

.image-source-text {
  margin-bottom: 0px;
}

.image-url-text {
  font-size: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 6s infinite linear !important;
}

@keyframes slide {

  0%,
  100% {
    transform: translateX(-100%);
  }

  50% {
    transform: translateX(0);
  }
}

.slide {
  animation: slide 3s infinite !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.pulse {
  animation: pulse 1s infinite alternate !important;
}

@keyframes swingRotate {
  0% {
    transform: rotate(-50deg);
  }

  50% {
    transform: rotate(50deg);
  }

  100% {
    transform: rotate(-50deg);
  }
}

.swingRotate {
  animation: swingRotate 2s ease-in-out infinite;
}

@keyframes verticalBounce {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-30px);
    /* Modifiez cette valeur pour ajuster l'amplitude */
  }

  100% {
    transform: translateY(0);
  }
}

.verticalBounce {
  animation: verticalBounce 1s ease-in-out infinite;
}


.loader {
  position: fixed;
  /* Position fixe par rapport à la fenêtre */
  top: 0;
  /* Alignement en haut */
  left: 0;
  /* Alignement à gauche */
  width: 100vw;
  /* Pleine largeur de la fenêtre */
  height: 100vh;
  /* Pleine hauteur de la fenêtre */
  background-color: white;
  /* Fond blanc opaque */
  display: flex;
  /* Pour centrer le spinner */
  justify-content: center;
  /* Centrage horizontal du spinner */
  align-items: center;
  /* Centrage vertical du spinner */
  z-index: 9999;
  /* Assurez-vous que le loader est au-dessus des autres éléments */
}
</style>
